module.exports = __webpack_public_path__ + "static/img/tj_a16.e29bd892.png";